import styles from './styles/CertificationCard.module.scss'

export default function CertificationCard() {
  return (
    <a
      href='https://www.padi.com/certification-cards?utm_campaign=ww-en-rcol-tran-email-seekadventure&utm_source=salesforce_crm&utm_medium=email&utm_content=cert_cards_2023'
      target='_blank'
      rel='noopener'
    >
      <img
        className={styles.image}
        src={`${window.staticPath}travel_dist/images/cert_card.jpg`}
      />
    </a>
  )
}
